<template>
  <div class="exportcheckpadding5">
    <div class="headermain mb-5 mt-5">
      <nav
        class="navbar navbar-expand-xl"
        id="navbar_top"
        style="display: block"
      >
        <div class="container">
          <div class="row w-100">
            <div class="col-md-6">
              <div class="d-flex flex-column">
                <router-link
                  :to="{ name: 'Home' }"
                  class="navbar-brand p-0"
                  :class="type != 'ViewData' ? 'logoDiv' : ''"
                >
                  <img
                    v-if="CompanyLogo"
                    :src="base64_image"
                    class="logomain logo"
                    alt="Company logo"
                    style="max-width: 70%"
                  />
                  <img
                    v-if="!CompanyLogo"
                    src="@/assets/images/logo.png"
                    class="logomain logo"
                    alt="Company logo"
                    style="max-width: 70%"
                  />
                </router-link>
                <h3 class="authornamechecks text-nowrap m-t-20">
                  {{ VehicleType }}
                  Inspections List
                </h3>
                <p class="m-t-20 m-b-0" v-if="FleetInspectionsList.length > 0">
                  <strong>Mechanic Name:</strong>
                  {{
                    VehicleInspections.mechanic_name
                      ? VehicleInspections.mechanic_name
                      : "N/A"
                  }}
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex align-items-center justify-content-end">
                <div class="" v-if="VehicleInspections.vehicle">
                  <div
                    class="exportchecksbox w-100 d-flex align-items-center mb-2"
                  >
                    <span class="exportcheckswidth">{{ VehicleType }}:</span>
                    <span class="bgwhite me-2">
                      <!--<img src="@/assets/images/GB.png" />-->
                      <span class="gbtext"
                        >&nbsp;{{ VehicleInspections.vehicle.vrm }}</span
                      >
                    </span>
                  </div>
                  <div
                    class="exportchecksbox w-100 d-flex align-items-center mb-2"
                  >
                    <span class="exportcheckswidth">Make:</span>
                    <span>&nbsp;{{ VehicleInspections.vehicle.make }}</span>
                  </div>
                  <div
                    class="exportchecksbox w-100 d-flex align-items-center mb-2"
                  >
                    <span class="exportcheckswidth">Model:</span>
                    <span>&nbsp;{{ VehicleInspections.vehicle.model }}</span>
                  </div>
                  <div
                    class="exportchecksbox w-100 d-flex align-items-center mb-2"
                  >
                    <span class="exportcheckswidth">Date:</span>
                    <span>&nbsp;{{ VehicleInspections.created_at_date }}</span>
                  </div>
                  <div
                    class="exportchecksbox w-100 d-flex align-items-center mb-2"
                  >
                    <span class="exportcheckswidth">Time:</span>
                    <span>&nbsp;{{ VehicleInspections.created_at_time }}</span>
                  </div>
                  <div
                    class="exportchecksbox w-100 d-flex align-items-center mb-2"
                    v-if="type == 'ViewData'"
                  >
                    <a
                      @click="GenerateInspectionPDF()"
                      id="save_pdf_btn"
                      class="btn btn-primary search-data pdf-btn"
                      >Save as PDF</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div class="main-content">
      <div class="container">
        <div class="row overviewevent mb-5">
          <template v-if="VehicleType == 'Crane'">
            <template v-for="(value, index) in FleetInspectionsList">
              <div
                :key="index"
                class="col-lg-6 col-xl-6 mb-3 m-b-20 print-w-50"
              >
                <div :key="index" class="item">
                  <div class="tableevents tableset">
                    <div class="tbodyscroll1">
                      <div class="table-responsive1">
                        <table class="table w-100 table-scroll1 table-striped">
                          <thead>
                            <tr>
                              <th>{{ value.category }}</th>
                              <th width="180">MC</th>
                              <th width="80">IM No</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-for="(
                                inspection, inspectionIndex
                              ) in value.inspections"
                            >
                              <tr
                                :key="inspectionIndex"
                                :class="
                                  inspection.name == 'Check base access.' ||
                                  inspection.name ==
                                    'Check the condition of Trolley rollers'
                                    ? 'html2pdf__page-break'
                                    : ''
                                "
                              >
                                <td>
                                  {{ inspection.name }}
                                </td>
                                <td>
                                  <span>{{
                                    inspection.submitted_value_title
                                  }}</span>
                                </td>
                                <td>
                                  <span>{{ inspection.im_no }}</span>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="col-lg-6 col-xl-6 mb-3 m-b-20 print-w-50">
              <template v-for="(value, index) in FleetInspectionsList">
                <div :key="index" class="item" v-if="index <= 2">
                  <div class="tableevents tableset">
                    <div class="tbodyscroll1">
                      <div class="table-responsive1">
                        <table class="table w-100 table-scroll1 table-striped">
                          <thead>
                            <tr>
                              <th>{{ value.category }}</th>
                              <th width="180">MC</th>
                              <th width="80">IM No</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-for="(
                                inspection, inspectionIndex
                              ) in value.inspections"
                            >
                              <tr
                                :key="inspectionIndex"
                                :class="
                                  inspection.name == 'View to front' ||
                                  inspection.name ==
                                    'Service brake operation/anti-lock warning'
                                    ? 'html2pdf__page-break'
                                    : ''
                                "
                              >
                                <td>
                                  {{ inspection.name }}
                                </td>
                                <td>
                                  <span>{{
                                    inspection.submitted_value_title
                                  }}</span>
                                </td>
                                <td>
                                  <span>{{ inspection.im_no }}</span>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="col-lg-6 col-xl-6 mb-3 m-b-20 print-w-50">
              <template v-for="(value, index) in FleetInspectionsList">
                <div
                  :key="index"
                  class="item InspectionsListDiv"
                  v-if="index > 2 && value.category_id != 6"
                >
                  <div class="tableevents tableset">
                    <div class="tbodyscroll1">
                      <div class="table-responsive1">
                        <table class="table w-100 table-scroll1 table-striped">
                          <thead>
                            <tr>
                              <th>{{ value.category }}</th>
                              <th width="100">MC</th>
                              <th width="100">IM No</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="inspection in value.inspections">
                              <tr>
                                <td>{{ inspection.name }}</td>
                                <td>
                                  <span>{{
                                    inspection.submitted_value_title
                                  }}</span>
                                </td>
                                <td>
                                  <span>{{ inspection.im_no }}</span>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>

          <div
            v-if="FleetInspectionsList.length > 0 && VehicleType == 'Trailer'"
            class="html2pdf__page-break"
          >
            &nbsp;
          </div>
          <div
            class="col-lg-12 col-xl-12 mb-3 m-b-20"
            v-if="FleetInspectionsList.length > 0 && VehicleType != 'Crane'"
          >
            <h5 class="text-center">TYRES</h5>
          </div>

          <div
            class="col-lg-6 col-xl-6 mb-3 print-w-50"
            v-if="FleetInspectionsList.length > 0 && VehicleType != 'Crane'"
          >
            <div class="innserSection">
              <template v-for="(value, index) in FleetInspectionsList">
                <table
                  :key="index"
                  class="table w-100 table-scroll1 table-striped"
                  v-if="value.category_id == 6"
                >
                  <thead>
                    <tr>
                      <th>&nbsp;</th>
                      <th width="180">MC</th>
                      <th width="100">IM No</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="inspection in value.inspections">
                      <tr>
                        <td>{{ inspection.name }}</td>
                        <td>
                          <span>{{ inspection.submitted_value_title }}</span>
                        </td>
                        <td>
                          <span>{{ inspection.im_no }}</span>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </template>
              <p class="text-center"><b>(strike out/amend boxes)</b></p>
              <p class="p-l-10"><b>TREAD WEAR/PRESSURE</b></p>
              <div class="TyresSection">
                <div class="text-right m-r-50">
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][0] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][0] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][1] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][1] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][2] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][2] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][3] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][3] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                </div>
                <div class="text-right m-r-50">
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][4] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][4] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][5] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][5] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                </div>
                <div class="text-right m-r-50">
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][6] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][6] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][7] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][7] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                </div>
                <div class="text-right m-r-50">
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][8] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][8] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][9] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][9] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][10] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][10] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][11] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][11] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                </div>
                <div class="p-10 text-right firstBox">
                  <div class="mm_psi_box">
                    <div class="mm_box">
                      <span>{{
                        tyresData["mm"] ? tyresData["mm"][12] : ""
                      }}</span>
                      <label>mm</label>
                    </div>
                    <div class="psi_box">
                      <span>{{
                        tyresData["psi"] ? tyresData["psi"][12] : ""
                      }}</span>
                      <label>psi</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-6 col-xl-6 mb-3 print-w-50"
            v-if="FleetInspectionsList.length > 0 && VehicleType != 'Crane'"
          >
            <div class="innserSection TyresAgeSection">
              <p class="text-center"><b>(strike out/amend boxes)</b></p>
              <p class="p-l-10"><b>TREAD AGE MARKINGS</b></p>
              <p class="p-l-10 p-b-50">
                (Mark box with NV if tyre markings visible)
              </p>
              <div class="TyresSection">
                <div class="p-10 text-right m-r-30">
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][0] : "" }}&nbsp;
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][1] : "" }}&nbsp;
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][2] : "" }}&nbsp;
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][3] : "" }}&nbsp;
                    </div>
                  </div>
                </div>
                <div class="p-10 text-right m-r-30">
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][4] : "" }}&nbsp;
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][5] : "" }}&nbsp;
                    </div>
                  </div>
                </div>
                <div class="p-10 text-right m-r-30">
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][6] : "" }}&nbsp;
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][7] : "" }}&nbsp;
                    </div>
                  </div>
                </div>
                <div class="p-10 text-right m-r-30">
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][8] : "" }}&nbsp;
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][9] : "" }}&nbsp;
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][10] : "" }}&nbsp;
                    </div>
                  </div>
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][11] : "" }}&nbsp;
                    </div>
                  </div>
                </div>
                <div class="p-10 text-right firstBox2">
                  <div class="mm_psi_box">
                    <div class="markings_box">
                      {{ tyresData["age"] ? tyresData["age"][12] : "" }}&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="FleetInspectionsList.length > 0 && VehicleType != 'Crane'"
            class="html2pdf__page-break"
          >
            &nbsp;
          </div>
          <div
            class="col-lg-12 col-xl-12 mb-3"
            v-if="brakesData.roadBrake && VehicleType != 'Crane'"
          >
            <div class="innserSection heightAuto p-10">
              <div class="col-lg-12 col-xl-12">
                <h5 class="p-b-10">
                  <b
                    >Part 3 : Road/Brake Test Report (*Delete as appropriate)</b
                  >
                </h5>
              </div>
              <div class="col-lg-12 col-xl-12">
                <div class="table-responsive mb-0">
                  <table
                    role="table"
                    aria-busy="false"
                    aria-colcount="4"
                    class="table b-table table-bordered"
                  >
                    <tbody role="rowgroup">
                      <!---->
                      <tr role="row" class="">
                        <td aria-colindex="1" role="cell" class="">
                          <b>Brake Performance</b><br />{{
                            brakesData.roadBrake.brake_performance
                          }}
                        </td>
                        <td aria-colindex="2" role="cell" class="">
                          <b
                            >Road Speed LIMITER Operational Yes/No* (*kph
                            *mph)</b
                          ><br />{{ brakesData.roadBrake.road_speed_limiter }}
                        </td>
                        <td rowspan="3" role="cell" class="">
                          <b>Load Condition Of Vehicle (laden* unladen*)</b
                          ><br />{{ brakesData.roadBrake.load_condition }}
                        </td>
                      </tr>
                      <tr role="row" class="">
                        <td aria-colindex="1" role="cell" class="">
                          <b>Decelerometer Test*</b><br /><br />{{
                            brakesData.roadBrake.decelerometer_test_kph
                          }}
                          kph*<br />{{
                            brakesData.roadBrake.decelerometer_test_mph
                          }}
                          mph*
                        </td>
                        <td aria-colindex="2" role="cell" class="">
                          <b>Road Conditions</b><br />
                          <div class="table-responsive mb-0">
                            <table
                              role="table"
                              aria-busy="false"
                              aria-colcount="4"
                              class="table b-table table-bordered"
                              id="__BVID__541"
                            >
                              <!----><!---->
                              <thead role="rowgroup" class="">
                                <!---->
                                <tr role="row" class="">
                                  <th>
                                    <div>Service (IM no 71)</div>
                                  </th>
                                  <th>
                                    <div>Service (IM no 72)</div>
                                  </th>
                                  <th>
                                    <div>Parking (IM no 73)</div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody role="rowgroup">
                                <tr role="row" class="">
                                  <td aria-colindex="1" role="cell" class="">
                                    {{ brakesData.roadBrake.service_im_71 }}
                                  </td>
                                  <td aria-colindex="2" role="cell" class="">
                                    {{ brakesData.roadBrake.service_im_72 }}
                                  </td>
                                  <td aria-colindex="3" role="cell" class="">
                                    {{ brakesData.roadBrake.parking_im_73 }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                      <tr role="row" class="">
                        <td colspan="2">
                          <b>Roller Brake Test*</b>
                          &nbsp;&nbsp;
                          {{ brakesData.roadBrake.roller_brake_test }}
                        </td>
                      </tr>
                      <tr role="row" class="">
                        <td colspan="3">
                          <b>Road Test - Overall Comments</b>
                          <br />
                          {{ brakesData.roadBrake.overall_comments }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-lg-12 col-xl-12 mb-3"
            v-if="brakesData.brakeTemperature && VehicleType != 'Crane'"
          >
            <div class="innserSection heightAuto p-10">
              <div class="col-lg-12 col-xl-12">
                <h5 class="p-b-10">
                  <b>Brake Temperature Assessment</b>
                </h5>
              </div>
              <div class="col-lg-12 col-xl-12">
                <div class="table-responsive mb-0">
                  <table
                    role="table"
                    aria-busy="false"
                    aria-colcount="4"
                    class="table b-table table-bordered"
                  >
                    <thead role="rowgroup" class="">
                      <tr role="row" class="">
                        <th>
                          <div>Side</div>
                        </th>
                        <th>
                          <div>Axle 1</div>
                        </th>
                        <th>
                          <div>Axle 2</div>
                        </th>
                        <th>
                          <div>Axle 3</div>
                        </th>
                        <th>
                          <div>Axle 4</div>
                        </th>
                        <th>
                          <div>Side</div>
                        </th>
                        <th>
                          <div>Axle 1</div>
                        </th>
                        <th>
                          <div>Axle 2</div>
                        </th>
                        <th>
                          <div>Axle 3</div>
                        </th>
                        <th>
                          <div>Axle 4</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody role="rowgroup">
                      <tr role="row" class="">
                        <td aria-colindex="1" role="cell" class="">O/S</td>
                        <td aria-colindex="2" role="cell" class="">
                          {{ brakesData.brakeTemperature.os_axle_1 }} &nbsp; *c
                        </td>
                        <td aria-colindex="3" role="cell" class="">
                          {{ brakesData.brakeTemperature.os_axle_2 }} &nbsp; *c
                        </td>
                        <td aria-colindex="1" role="cell" class="">
                          {{ brakesData.brakeTemperature.os_axle_3 }} &nbsp; *c
                        </td>
                        <td aria-colindex="2" role="cell" class="">
                          {{ brakesData.brakeTemperature.os_axle_4 }} &nbsp; *c
                        </td>
                        <td aria-colindex="3" role="cell" class="">N/S</td>
                        <td aria-colindex="1" role="cell" class="">
                          {{ brakesData.brakeTemperature.ns_axle_1 }} &nbsp; *c
                        </td>
                        <td aria-colindex="2" role="cell" class="">
                          {{ brakesData.brakeTemperature.ns_axle_2 }} &nbsp; *c
                        </td>
                        <td aria-colindex="1" role="cell" class="">
                          {{ brakesData.brakeTemperature.ns_axle_3 }} &nbsp; *c
                        </td>
                        <td aria-colindex="2" role="cell" class="">
                          {{ brakesData.brakeTemperature.ns_axle_4 }} &nbsp; *c
                        </td>
                      </tr>

                      <tr role="row" class="">
                        <td colspan="3"><b>Date of braking assessment</b></td>
                        <td colspan="7">
                          {{ brakesData.brakeTemperature.assessment_date }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-12 col-xl-12 d-none"
            v-if="brakesData.brakeTemperature && VehicleType != 'Crane'"
          >
            <div class="innserSection heightAuto mb-3" style="max-width: 400px">
              <div class="table-responsive mb-0">
                <table
                  role="table"
                  aria-busy="false"
                  aria-colcount="6"
                  class="table b-table"
                >
                  <!----><!---->
                  <thead role="rowgroup" class="">
                    <!---->
                    <tr role="row" class="thead-dark">
                      <th class="text-center" colspan="2">OPTIONAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!---->
                    <tr role="row" class="">
                      <td class="text-center" colspan="2">
                        Digital Tachograph
                      </td>
                    </tr>
                    <tr role="row" class="">
                      <td aria-colindex="1" role="cell" class="">
                        Data Download
                      </td>
                      <td aria-colindex="2" role="cell" class="">
                        {{ brakesData.brakeTemperature.data_download }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            class="col-lg-12 col-xl-12 mb-3 mobile-view"
            v-if="brakesData.vehicle && VehicleType != 'Crane'"
            :class="
              VehicleInspections.vehicle.class == 'Trailer' ? 'd-none' : ''
            "
          >
            <br v-if="type == 'PrintPDF'" />
            <br v-if="type == 'PrintPDF'" />
            <div class="innserSection heightAuto p-10">
              <div class="col-lg-12 col-xl-12">
                <h5 class="p-b-10"><b>BRAKES</b></h5>
                <h6><b>VEHICLE</b></h6>
              </div>
              <div class="col-lg-12 col-xl-12">
                <div class="row m-b-20">
                  <div class="col-lg-12 col-xl-12 text-center">
                    <img
                      src="@/assets/images/trucks/truck_1.png"
                      class="m-r-20"
                      alt="Break"
                    />
                    Total Weight: {{ brakesData["vehicle"]["total_weight"] }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-xl-4 print-w-33 text-right">
                    S.B. Force:
                    {{ brakesData["vehicle"]["sb_force"] }} kgf<br />
                    Eff.:
                    {{
                      brakesData["vehicle"]["sb_eff"]
                        ? brakesData["vehicle"]["sb_eff"]
                        : "-- "
                    }}
                    %
                  </div>
                  <div class="col-lg-4 col-xl-4 print-w-33 text-center">
                    P.B. Force:
                    {{ brakesData["vehicle"]["pb_force"] }} kgf<br />
                    Eff.:
                    {{
                      brakesData["vehicle"]["pb_eff"]
                        ? brakesData["vehicle"]["pb_eff"]
                        : "-- "
                    }}
                    %
                  </div>
                  <div class="col-lg-4 col-xl-4 print-w-33 text-left">
                    E.B. Force:
                    {{ brakesData["vehicle"]["eb_force"] }} kgf<br />
                    Eff.:
                    {{
                      brakesData["vehicle"]["eb_eff"]
                        ? brakesData["vehicle"]["eb_eff"]
                        : "-- "
                    }}
                    %
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-12 col-xl-12 mb-3 mobile-view-brake"
            v-if="brakesData.brakes && VehicleType != 'Crane'"
            :class="
              VehicleInspections.vehicle.class == 'Trailer' ? 'd-none' : ''
            "
          >
            <div class="innserSection heightAuto p-10">
              <div class="col-lg-12 col-xl-12">
                <h5 class="p-b-10"><b>BRAKES</b></h5>
              </div>
              <div
                class="col-lg-12 col-xl-12 m-b-30"
                v-for="(brake, brakeIndex) in brakesData.brakes"
                :key="brakeIndex"
              >
                <div class="row">
                  <div class="col-lg-3 col-xl-3 print-w-33">
                    <h5>
                      {{ brake.brake_no }}
                      <img
                        v-if="brake.left_p == ''"
                        src="@/assets/images/trucks/truck_3.png"
                        class="m-l-20"
                        alt="Break"
                      />
                      <img
                        v-if="brake.left_p != ''"
                        src="@/assets/images/trucks/truck_2.png"
                        class="m-l-20"
                        alt="Break"
                      />
                    </h5>
                  </div>
                  <div class="col-lg-9 col-xl-9 print-w-67">
                    <div class="row">
                      <div class="col-lg-3 col-xl-3 print-w-25">
                        Left: {{ brake.left }} kgf
                      </div>
                      <div class="col-lg-3 col-xl-3 print-w-25">
                        Right: {{ brake.right }} kgf
                      </div>
                      <div class="col-lg-3 col-xl-3 print-w-25">
                        L.Oval: {{ brake.l_oval }}%
                      </div>
                      <div class="col-lg-3 col-xl-3 print-w-25">
                        R.Oval: {{ brake.r_oval }}%
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4 col-xl-4 print-w-33 text-center">
                        IMBA.: {{ brake.imba }}% <br />Max.IMBA.:
                        {{ brake.max_imba }}%
                      </div>
                      <div class="col-lg-4 col-xl-4 print-w-33 text-center">
                        <span v-if="brake.left_p == ''"
                          >PADEL F.:
                          {{ brake.pedal_f ? brake.pedal_f : "--" }} kgf</span
                        >
                        <span v-if="brake.left_p != ''"
                          >Left P: {{ brake.left_p }}kgf &nbsp; &nbsp; &nbsp;
                          &nbsp; &nbsp; Right P: {{ brake.right_p }} kgf</span
                        ><br />
                        Weight: {{ brake.weight }} kg &nbsp; &nbsp; &nbsp;
                        &nbsp; &nbsp; Eff.: {{ brake.eff }} %
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-2 col-xl-2 print-w-20">
                        L.M.I: {{ brake.lmi }} kgf<br />
                        L.R.R.: {{ brake.lrr }} kgf
                      </div>
                      <div class="col-lg-2 col-xl-2 print-w-20">
                        R.M.I: {{ brake.rmi }} kgf<br />
                        R.R.R.: {{ brake.rrr }} kgf
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="FleetInspectionsList.length > 0 && VehicleType == 'Trailer'"
            class="html2pdf__page-break"
          >
            &nbsp;
          </div>

          <div
            class="col-lg-12 col-xl-12 mb-3 rectification-mobile-view"
            v-if="FleetInspectionsList.length > 0"
          >
            <div class="innserSection border-red heightAuto p-10">
              <h5 class="text-center m-b-20">Rectifications</h5>
              <div class="form theme-form m-b-30">
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xl-12 m-b-20">
                    <h6>Needing Immediate Attention</h6>
                  </div>
                </div>
                <div v-if="VehicleInspections.rectifications">
                  <template
                    v-for="(
                      rectData, index
                    ) in VehicleInspections.rectifications"
                  >
                    <div
                      class="row m-b-10 rectified-single-row"
                      :key="index"
                      v-if="rectData.type == 2"
                    >
                      <div class="col-lg-4 col-sm-4 col-xl-4">
                        <label>{{ rectData.name }}</label>
                      </div>
                      <div class="col-lg-4 col-sm-4 col-xl-4">
                        {{ rectData.value }}
                      </div>
                      <div class="col-lg-3 col-sm-3 col-xl-3">
                        <span v-if="rectData.cost"
                          >Costing -{{ currency_type + rectData.cost }}</span
                        >
                      </div>
                      <div class="col-lg-1 col-sm-1 col-xl-1">
                        <a
                          v-if="rectData.file_name"
                          v-b-tooltip.hover
                          title="View Document"
                          @click="DownloadDocument(rectData.file_name)"
                          target="_blank"
                          class="btn btn-primary right pl-2 pr-2 mr-2"
                          ><font-awesome-icon
                            icon="fa-solid fa-file-text"
                            class="view-doc-icon right"
                        /></a>
                      </div>
                    </div>
                  </template>
                </div>
                <div v-else>N/A</div>
              </div>
              <div class="form theme-form">
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xl-12 m-b-20">
                    <h6>Less Urgent - For Early Attention</h6>
                  </div>
                </div>
                <div v-if="VehicleInspections.rectifications">
                  <template
                    v-for="(
                      rectData, index
                    ) in VehicleInspections.rectifications"
                  >
                    <div
                      class="row m-b-10"
                      :key="index"
                      v-if="rectData.type == 5"
                    >
                      <div class="col-lg-4 col-sm-4 col-xl-4">
                        <label>{{ rectData.name }}</label>
                      </div>
                      <div class="col-lg-4 col-sm-4 col-xl-4">
                        {{ rectData.value }}
                      </div>
                      <div class="col-lg-3 col-sm-3 col-xl-3">
                        <span v-if="rectData.cost"
                          >Costing - {{ currency_type + rectData.cost }}</span
                        >
                      </div>
                      <div class="col-lg-1 col-sm-1 col-xl-1">
                        <a
                          v-if="rectData.file_name"
                          v-b-tooltip.hover
                          title="View Document"
                          @click="DownloadDocument(rectData.file_name)"
                          target="_blank"
                          class="btn btn-primary right pl-2 pr-2 mr-2"
                          ><font-awesome-icon
                            icon="fa-solid fa-file-text"
                            class="view-doc-icon right"
                        /></a>
                      </div>
                    </div>
                  </template>
                </div>
                <div v-else>N/A</div>
              </div>
            </div>
          </div>

          <div
            class="col-lg-12 col-xl-12 mb-3"
            v-if="FleetInspectionsList.length > 0"
          >
            <b>Notes:</b> {{ VehicleInspections.notes }}
            <span
              class="bluebg1 commonpas notesbtn"
              v-if="VehicleInspections.notes == ''"
              >N/A</span
            >
          </div>
          <div
            class="col-lg-12 col-xl-12 mb-3"
            v-if="FleetInspectionsList.length > 0"
            :class="
              VehicleInspections.vehicle.class == 'Trailer' ? 'd-none' : ''
            "
          >
            <b>Current {{ MileageUnit }} :</b>
            {{ VehicleInspections.current_mileage }}
            <span
              class="bluebg1 commonpas notesbtn"
              v-if="VehicleInspections.current_mileage == ''"
              >N/A</span
            >
          </div>
          <div
            class="col-lg-12 col-xl-12 mb-3"
            v-if="FleetInspectionsList.length > 0"
          >
            <div class="row">
              <template v-for="value in FleetInspectionsList">
                <template v-for="inspection in value.inspections">
                  <template
                    v-if="
                      Array.isArray(inspection.submitted_value_photo) &&
                      inspection.submitted_value_photo.length > 0
                    "
                  >
                    <template
                      v-for="(
                        photo, photoIndex
                      ) in inspection.submitted_value_photo"
                    >
                      <div class="col-xl-3 col-sm-3 mb-3" :key="photoIndex">
                        <a
                          ><img
                            :src="ImageEndpoint + submitted_value_photo"
                            class="img-thumbnail"
                            alt="Image description"
                        /></a>
                        <span>{{ inspection.name }}</span>
                      </div>
                    </template>
                  </template>
                </template>
              </template>
            </div>
          </div>
          <div
            class="col-lg-12 col-xl-12 mb-3 text-right"
            v-if="type == 'ViewData'"
          >
            <button @click="PrintReport()" class="print_btn">Print</button>
          </div>
        </div>
      </div>
    </div>
    <div class="footerdif">
      <div class="row">
        <div class="col-md-12 text-center">
          <img src="@/assets/images/logo.png" style="width: 100px" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
var moment = require("moment");
import $ from "jquery";

import GetcurrencySymbol from "@/assets/js/currency_sign.js";
export default {
  components: {},
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  props: [
    "FleetInspectionsList",
    "tyresData",
    "brakesData",
    "VehicleInspections",
    "CompanyLogo",
    "VehicleType",
    "type",
  ],
  data() {
    return {
      currency_type : GetcurrencySymbol(),
      ImageEndpoint: Endpoints.Helper.Image + "/",
      MileageUnit: "Mileage",
      base64_image: "",
    };
  },
  mounted() {
    var Company = JSON.parse(localStorage.getItem("Company"));
    if (Company && Company.mileage_unit == 2) {
      this.MileageUnit = "KM";
    }
    this.GenerateBase64Logo();
  },
  methods: {
    GenerateBase64Logo() {
      var obj = {
        token: localStorage.getItem("token"),
        url: this.CompanyLogo,
      };
      Axios.post(Endpoints.File.GetBase64Image, obj).then((Response) => {
        if (Response?.data?.success) {
          this.base64_image = Response.data.image_data;
        }
      });
    },
    DownloadDocument(file) {
      window.open(this.ImageEndpoint + file, "_blank");
    },
    PrintReport() {
      window.print();
    },
    GenerateInspectionPDF() {
      $("#save_pdf_btn").html("Processing...");
      this.$root.$emit("GenerateInspectionPDF");
    },
  },
};
</script>
<style scoped>
.logoDiv {
  max-width: 70%;
  height: 65px;
  overflow: hidden;
}
.logoDiv img {
  width: auto !important;
  height: 100%;
}
.table td {
  padding-left: 0.75rem !important;
}
.InspectionsListDiv {
  padding-right: 17px;
  margin-bottom: 20px;
}
.print_btn {
  border: 1px solid;
  padding: 10px 25px;
}
.custom-scrollbar thead th {
  top: -1px;
}
.innserSection {
  display: block;
  border: 1px solid #ccc;
  height: 450px;
}
.mm_psi_box {
  display: inline-block;
  width: 100px;
  text-align: center;
  margin-right: 5px;
}
.mm_box,
.psi_box {
  display: inline-block;
  width: 50px;
}
.mm_box span,
.psi_box span {
  border: 1px solid #ccc;
  display: block;
  width: 50px;
  padding: 3px 0;
  margin: 0;
  height: 30px;
}
.mm_box label,
.psi_box label {
  display: block;
  line-height: 13px;
}
.markings_box {
  display: inline-block;
  width: 100px;
  border: 1px solid #ccc;
  padding: 3px 0;
  height: 30px;
}

.firstBox2 .markings_box {
  width: 160px !important;
}

.firstBox .markings_box,
.firstBox2 .markings_box {
  width: 150px;
  height: 30px;
}
.firstBox .mm_psi_box {
  width: 150px;
}
.firstBox .mm_box,
.firstBox .psi_box,
.firstBox2 .mm_box,
.firstBox2 .psi_box,
.firstBox .psi_box span,
.firstBox .mm_box span {
  width: 75px;
  height: 30px;
}
.firstBox {
  transform: rotate(270deg);
  width: 200px;
  position: absolute;
  right: -76px;
  top: 76px;
}
.firstBox2 {
  transform: rotate(270deg);
  width: 200px;
  position: absolute;
  right: -78px;
  top: 138px;
}
.TyresSection {
  position: relative;
}
.heightAuto {
  height: auto;
}

.innserSection .table-bordered td,
.innserSection .table-bordered th {
  border-color: #dfdfdf !important;
}
.border-red {
  border-color: #f00;
}
@media (max-width: 760px) {
  .mm_psi_box {
    width: 60px;
  }
  .mm_box,
  .psi_box {
    width: 30px;
  }
  .mm_box span,
  .psi_box span {
    width: 32px;
  }
  .TyresAgeSection .mm_psi_box {
    width: 53px;
  }
  .TyresAgeSection .markings_box {
    width: 61px;
  }
  .TyresAgeSection .firstBox2 {
    top: 186px;
  }
  .TyresAgeSection .p-b-50 {
    padding-bottom: 0px !important;
  }
  .TyresAgeSection .m-r-30 {
    margin-right: 40px;
  }
  .TyresAgeSection {
    height: 323px !important;
    padding-top: 6px;
  }
  .mobile-view .col-lg-4 {
    width: 33%;
    float: left;
  }
  .mobile-view-brake .print-w-25 {
    width: 25%;
  }
  .mobile-view-brake .print-w-33 {
    width: 50%;
    text-align: left !important;
  }
  .mobile-view-brake .print-w-20 {
    width: 50%;
  }
  .rectification-mobile-view .col-lg-4 {
    padding-bottom: 10px;
  }
  .rectification-mobile-view .col-lg-3 {
    padding-bottom: 10px;
  }
  .rectification-mobile-view .col-lg-1 {
    padding-bottom: 10px;
  }
  .headermain {
    margin-bottom: 10px !important;
  }
}
@media print {
  .print_btn {
    display: none;
  }
  .print-w-50 {
    width: 50% !important;
  }
  .print-w-25 {
    width: 25% !important;
  }
  .print-w-33 {
    width: 33% !important;
  }
  .print-w-20 {
    width: 20% !important;
  }
  .print-w-67 {
    max-width: 67% !important;
  }
  .print-w-50 .InspectionsListDiv {
    overflow: auto !important;
    height: auto !important;
  }
  .mm_psi_box {
    width: 80px !important;
  }
  .mm_box span,
  .psi_box span {
    width: 40px !important;
  }
  .mm_box,
  .psi_box {
    display: inline-block;
    width: 40px;
  }
  .firstBox .mm_box,
  .firstBox .psi_box,
  .firstBox2 .mm_box,
  .firstBox2 .psi_box,
  .firstBox .psi_box span,
  .firstBox .mm_box span {
    display: inline-block;
    width: 75px !important;
  }
  .firstBox .mm_psi_box {
    width: 150px !important;
  }
  .firstBox {
    width: 160px !important;
    top: 60px;
    right: -55px;
  }
  .firstBox2 {
    top: 160px;
  }
  .markings_box {
    width: 80px !important;
  }
  .pdf-btn {
    display: none;
  }
}
</style>
